var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowcasebig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20.34pt",
    height: "13.031pt",
    viewBox: "0 0 20.34 13.031",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.82-4.4931e-6c-1.4179 0-2.7304 0.46094-3.8008 1.2305l0.1524 0.20312 0.1406-0.20312c-1.0625-0.76953-2.3828-1.2305-3.8008-1.2305-3.5898 0-6.5117 2.9141-6.5117 6.5156 0 3.5976 2.9219 6.5156 6.5117 6.5156 1.418 0 2.7383-0.46094 3.8008-1.2305l-0.1406-0.20312-0.1524 0.20312c1.0704 0.76953 2.3829 1.2305 3.8008 1.2305 3.6016 0 6.5196-2.918 6.5196-6.5156 0-3.6016-2.918-6.5156-6.5196-6.5156v0.5c1.6719 0 3.1719 0.67188 4.2617 1.7617 1.0899 1.0898 1.7579 2.5898 1.7579 4.2539 0 1.6602-0.668 3.1641-1.7579 4.2539-1.0898 1.0898-2.5898 1.7617-4.2617 1.7617-1.3086 0-2.5195-0.42187-3.5078-1.1367l-0.1406-0.10547-0.1524 0.10547c-0.9882 0.71485-2.1875 1.1367-3.5078 1.1367-1.6601 0-3.1601-0.67187-4.25-1.7617-1.0898-1.0898-1.7617-2.5937-1.7617-4.2539 0-1.6641 0.6719-3.1641 1.7617-4.2539 1.0899-1.0898 2.5899-1.7617 4.25-1.7617 1.3203 0 2.5196 0.42578 3.5078 1.1367l0.1524 0.10156 0.1406-0.10156c0.9883-0.71094 2.1992-1.1367 3.5078-1.1367",
    fill: "#231f20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcasebig);
export default __webpack_public_path__ + "static/media/showcasebig.9f0622c548f88f97c70d1ece3acbb4f7.svg";
export { ForwardRef as ReactComponent };